import React from 'react';
import BotoneraDesplegable from '../UI/BotoneraDesplegable.js';
import ListaTiposTorneoOrganizadorInt from './ListaTiposTorneoOrganizadorInt.js';

const BotoneraOrganizadoresInt = (props) => {
  const organizadores = Array.isArray(props.organizadores) ? props.organizadores : [];

  return (
    <BotoneraDesplegable
      lista={organizadores}
      renderBody={(item) => <ListaTiposTorneoOrganizadorInt organizador={item} />}
      desplegarPrimero={false}
    />
  );
};

export default BotoneraOrganizadoresInt;
